import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import moment from 'moment';
import Tooltip from 'reactstrap/lib/UncontrolledTooltip';
import { SetComponentLanguage, ApiRequest } from '../../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './SearchResultsTicket.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class SearchResultsTicket extends Component {
    constructor(props) {
        super(props);
    }
    
    ticketButtons(param) {
        const eventsResults = this.props.eventsResults;
        let eventPayedOut = false;
        eventsResults.forEach((event) => {
            if (event.id === param.ticket.event_id) {
                if (event.payout_created) {
                    eventPayedOut = true;
                }
            }
        });
        if(param.transaction.status !== 'released'){
            switch(param.ticket.status) {
                case '':
                    if (!eventPayedOut && param.transaction.status !== 'refunded') {
                        return (
                            <div className="showtix-search__transaction__buttons">
                                <div className="showtix-dropdown">
                                    <span className="showtix-button showtix-button__xsmall showtix-background__grey-3">{strings.releaseOptions}</span>
                                    <div className="showtix-dropdown__body">
                                        <button 
                                            className="showtix-button showtix-button__xsmall showtix-background__primary-3"
                                            onClick={this.props.toggleReleaseRefundModal}
                                            id={param.ticket.id}
                                            title={strings.releaseTitle}
                                            description={strings.releaseDescription}
                                            transaction_id={param.transaction.id}
                                            action="release-refund"
                                            type="ticket"
                                        >
                                            {strings.releaseRefund}
                                        </button>
                                        
                                        <button 
                                            className="showtix-button showtix-button__xsmall showtix-background__primary-3"
                                            onClick={this.props.toggleAlertModal}
                                            id={param.ticket.id}
                                            title={strings.releaseTitle}
                                            description={strings.releaseDescription}
                                            action="release"
                                            type="ticket"
                                        >
                                            {strings.release}<br />{strings.releasePart2}
                                        </button>
                                    </div>    
                                </div>
                            </div>
                        )
                    } else {
                        return null;
                    }

                    
    
                case 'released':
                    if(this.props.user.role === 'admin' || this.props.isGodMode) {
                        if (!eventPayedOut) {
                            return  (
                                <div className="showtix-search__transaction__buttons">
                                    <button 
                                        className="showtix-button showtix-button__xsmall showtix-background__primary-4"
                                        onClick={this.props.toggleAlertModal}
                                        id={param.ticket.id}
                                        title={strings.deleteTitle}
                                        description={strings.deleteDescription}
                                        action="delete"
                                        type="ticket"
                                    >
                                        {strings.delete}
                                    </button>
                                </div>
                            );
                        } else {
                            return null;
                        }
                    } else {
                        return null;
                    }
    
                case 'reserved':
                    if (!eventPayedOut) {
                        return (
                            <div className="showtix-search__transaction__buttons">
                                <button 
                                    className="showtix-button showtix-button__xsmall showtix-background__primary-4"
                                    onClick={this.props.toggleAlertModal}
                                    id={param.ticket.id}
                                    title={strings.deleteTitle}
                                    description={strings.deleteDescription}
                                    action="delete"
                                    type="ticket"
                                    reserved="reserved"
                                >
                                    {strings.delete}
                                </button>
                            </div>
                        );
                    } else {
                        return null;
                    }

                case 'vipatron':
                    if (!eventPayedOut) {
                        return (
                            <div className="showtix-search__transaction__buttons">
                                <button 
                                    className="showtix-button showtix-button__xsmall showtix-background__primary-4"
                                    onClick={this.props.toggleAlertModal}
                                    id={param.ticket.id}
                                    title={strings.deleteTitle}
                                    description={strings.deleteDescription}
                                    action="delete"
                                    type="ticket"
                                    reserved="reserved"
                                >
                                    {strings.delete}
                                </button>
                            </div>
                        );
                    } else {
                        return null;
                    }

                case 'temporary':
                    if (!eventPayedOut) {
                        return (
                            <div className="showtix-search__transaction__buttons">
                                <button 
                                    className="showtix-button showtix-button__xsmall showtix-background__primary-4"
                                    onClick={this.props.toggleAlertModal}
                                    id={param.ticket.id}
                                    title={strings.deleteTitle}
                                    description={strings.deleteDescription}
                                    action="delete"
                                    type="ticket"
                                >
                                    {strings.delete}
                                </button>
                            </div>
                        );    
                    } else {
                        return null;
                    }
    
                case 'sold':
                    if (!eventPayedOut && this.props.transaction.status !== 'refunded') {
                        return (
                            <div className="showtix-search__transaction__buttons">
                                <div className="showtix-dropdown">
                                    <span className="showtix-button showtix-button__xsmall showtix-background__grey-3">{strings.releaseOptions}</span>
                                    <div className="showtix-dropdown__body">
                                        <button 
                                            className="showtix-button showtix-button__xsmall showtix-background__primary-3"
                                            onClick={this.props.toggleReleaseRefundModal}
                                            id={param.ticket.id}
                                            title={strings.releaseTitle}
                                            description={strings.releaseDescription}
                                            transaction_id={param.transaction.id}
                                            action="release-refund"
                                            type="ticket"
                                        >
                                            {strings.releaseRefund}
                                        </button>
                                        
                                        <button 
                                            className="showtix-button showtix-button__xsmall showtix-background__primary-3"
                                            onClick={this.props.toggleAlertModal}
                                            id={param.ticket.id}
                                            title={strings.releaseTitle}
                                            description={strings.releaseDescription}
                                            action="release"
                                            type="ticket"
                                        >
                                            {strings.release}<br />{strings.releasePart2}
                                        </button>
                                    </div>    
                                </div>
                            </div>
                        );
                    } else {
                        return null;
                    }
    
                default:
                    return (
                        <div className="showtix-search__transaction__buttons">
                            
                        </div>   
                    );        
            }
        } else {
            if(this.props.user.role === 'admin') {
                switch(param.ticket.status) {
                    case 'released':
                        if (!eventPayedOut) {
                            return  (
                                <div className="showtix-search__transaction__buttons">
                                    <button 
                                        className="showtix-button showtix-button__xsmall showtix-background__primary-4"
                                        onClick={this.props.toggleAlertModal}
                                        id={param.ticket.id}
                                        title={strings.deleteTitle}
                                        description={strings.deleteDescription}
                                        action="delete"
                                        type="ticket"
                                    >
                                        {strings.delete}
                                    </button>
                                </div>
                            );
                        } else {
                            return null;
                        }
        
                    default:
                        return (
                            <div className="showtix-search__transaction__buttons">
                                
                            </div>   
                        );        
                }
            }
        }
    }

    componentDidMount() {
        
    }

    renderDiscountFlexpass = (classes = 'd-md-none d-lg-none ') => {
        if (this.props.ticket.coupon_discount > 0 || this.props.ticket.flexpass_used) {
            if (this.props.ticket.flexpass_used) {
                return (
                    <div className={classes + "showtix-search__transaction__ticket__discount is-active"}>
                        {strings.flexpassUsed} {this.props.ticket.flexpass_name} ({this.props.ticket.flexpass_code}) <span className="showtix-badge showtix-background__primary-1">{strings.flexpassTx} {this.props.ticket.flexpass_purchase_transaction_id}</span>
                    </div>
                )
            } else {
                return (
                    <div className={classes + "showtix-search__transaction__ticket__discount is-active"}>
                        {strings.discountApplied}
                        -{new Intl.NumberFormat('en-US', {
                            style: 'currency',
                            currency: 'USD'
                        }).format(this.props.ticket.coupon_discount)}
                    </div>
                )
            }
        }
    };
    
    renderEventName = () => {
        const eventsResults = this.props.eventsResults;
        let eventName = '';
        eventsResults.forEach((result) => {
            if(result.id === this.props.ticket.event_id) {
                eventName = result.name;
            }
        });
        if (eventName !== '') {
            return eventName;
        } else {
            return '-';
        }
    }

    renderEventDate(dateId) {
        let dateString = '';
        const events = this.props.events;
        events.forEach((event) => {
            event.event_dates.forEach((event_date) => {
                if (parseInt(event_date.id, 10) === parseInt(dateId, 10)) {
                    dateString = moment(event_date.event_datetime_local.substring(0, 19)).format('LLLL')
                }
            });
        });
        return (
            dateString
        );
    }

    renderSeat = (ticket: Object) => {
        if (!ticket.activation_code) {
            return (
                <div className="showtix-search__transaction__title__item">
                    <span>Seat:</span>
                    {this.props.ticket.full_seat_name !== undefined &&
                        (this.props.ticket.full_seat_name)
                    }
                </div>
            )
        } else {
            return (
                <div className="showtix-search__transaction__title__item">
                    <span>Stream Code:</span>
                    {this.props.isGodMode ? (
                        <a href={`/stream/${ticket.activation_code}?event_id=${ticket.event_id}`} target="_blank">{ticket.activation_code}</a>
                    ) : (
                        ticket.activation_code
                    )}
                    {ticket.redeem_datetime && (
                        <React.Fragment>
                            <span id={`tooltip-accesscode-${ticket.id}`} className="showtix-tooltip">!</span>
                            <Tooltip placement="top" target={`tooltip-accesscode-${ticket.id}`}>
                                Redeemed: {moment(ticket.redeem_datetime.substring(0, 19)).format('LLLL')}
                            </Tooltip>
                        </React.Fragment>
                    )}
                </div>
            );
        }
    };

    render() {
        return (   
            <div className="showtix-search__transaction__ticket">
                <div className="showtix-search__transaction__title">
                    <div className="showtix-search__transaction__title__item">
                        {this.renderEventName()} &mdash; {this.renderEventDate(this.props.ticket.event_date_id)}
                    </div>
                    
                    {(this.props.transaction.status === 'released' || this.props.ticket.status === 'released') &&
                        <div className="showtix-search__transaction__title__item">
                            <span>Status:</span>
                            <span className="showtix-badge showtix-background__primary-1">{strings.released}</span>
                        </div>
                    }
                    {this.props.ticket.status === 'refunded' &&
                        <div className="showtix-search__transaction__title__item">
                            <span>Status:</span>
                            <span className="showtix-badge showtix-background__primary-2">{strings.refunded}</span>
                        </div>
                    }
                    
                    {this.renderSeat(this.props.ticket)}
                    
                    <div className="showtix-search__transaction__title__item">
                        <span>Price:</span>
                            {this.props.ticket.price > 0 ?
                                <React.Fragment>
                                    {new Intl.NumberFormat('en-US', {
                                        style: 'currency',
                                        currency: 'USD'
                                    }).format(this.props.ticket.price)}
                                </React.Fragment>
                            : 
                            <React.Fragment>
                                {new Intl.NumberFormat('en-US', {
                                    style: 'currency',
                                    currency: 'USD'
                                }).format(0.00)}
                            </React.Fragment>
                            }
                    </div>
                    
                    {this.renderDiscountFlexpass('d-md-none d-lg-none ')}
                </div>    
                { !this.props.archived && 
                    this.ticketButtons(this.props)
                }
                {this.renderDiscountFlexpass('d-none d-md-block d-lg-block ')}
            </div>
        )
    }
}

SearchResultsTicket.propTypes = {
    ticket: PropTypes.shape({
        date: PropTypes.string,
        event: PropTypes.string,
        id: PropTypes.number,
        seat: PropTypes.string,
        price: PropTypes.number,
        status: PropTypes.string,
        checkinStatus: PropTypes.string
    }),
    archived: PropTypes.bool,
    toggleAlertModal: PropTypes.func
}

export default SearchResultsTicket;


// WEBPACK FOOTER //
// ./src/components/Search/SearchResults/SearchResultsTicket/SearchResultsTicket.js